import React from 'react'
import { Box, Button as ButtonG } from 'grommet'
import { Hide } from 'grommet-icons'
import styled, { css } from 'styled-components'
import { useHideInput } from '../../contextHook/hideInput'

const AppearStyle = css`
  opacity: 1;
  right: 0;
  transition-timing-function: step-end;
  visibility: visible;
`

const UnhideInputButtonBox = styled(Box)`
  position: absolute;
  z-index: 10;
  right: -4rem;
  top: -4rem;
  transform-origin: bottom right;
  transform: rotate(270deg);
  transition: opacity 0.35s;
  transition-timing-function: step-start;
  opacity: 0;
  visibility: hidden;
  ${props => props.shouldAppear && AppearStyle}
`

const Button = styled(ButtonG)`
  color: ${props => props.theme.global.colors.text};
  padding: 0.8rem 1.6rem;
  /* border-bottom-left-radius: 1rem; */
  border-top-left-radius: 1rem;
  /* border-bottom-right-radius: 1rem; */
  box-shadow: -5px 0 5px 0px rgba(0, 0, 0, 0.16);
`

const UnhideInputButton = () => {
  const { hiding, setHiding } = useHideInput()
  // if (!hiding) return null
  return (
    <UnhideInputButtonBox shouldAppear={hiding}>
      <Button
        icon={<Hide color="iconDarkLight" />}
        label="INPUTS"
        primary
        color="secondaryBg"
        gap=".8rem"
        onClick={() => {
          setHiding(false)
        }}
      ></Button>
    </UnhideInputButtonBox>
  )
}

export default UnhideInputButton
